import { List, Popover, Tag } from "antd";
import { CheckCircleFilled, CloseCircleFilled, ExclamationCircleFilled } from '@ant-design/icons';
import { DataType } from "../../interface";
import Loader from "@/components/Loader";
import "./index.less";
import { strDot } from "@/utils";
import { cdnUrl } from '@/utils/cdn';
export default function MultiState({ wallet, executionTimes }: { wallet: DataType, executionTimes: number }) {

  return (
    <div className="multi-state">
      <Popover
        overlayClassName="multi-state-popover"
        content={
          wallet.successHashs?.map((hash: string, index: number) => (
            <div key={index}>{`${index + 1}. ${strDot(hash)}`}</div>
          ))

          // <List
          //   size="small"
          //   dataSource={wallet.successHashs}
          //   renderItem={(hash, index) => <List.Item>{`${index + 1}. ${strDot(hash)}`}</List.Item>}
          // />
        }
        title="HASH(46)"
      >
        <Tag className="success-tag">
          <CheckCircleFilled className="success-icon" />
          <p>{wallet.successHashs?.length}</p>
        </Tag>
      </Popover>
      <Tag className="fail-tag">
        <CloseCircleFilled className="fail-icon" />
        <p>{wallet.failedCount}</p>
      </Tag>
      <Tag className="tips-tag">
        <ExclamationCircleFilled className="tips-icon" />
        <p>{
          wallet.status === 1
            ? executionTimes - (wallet.successHashs?.length || 0) - (wallet.failedCount || 0)
            : 0
        }</p>
      </Tag>
      {
        wallet.status === 1
        &&
        <Loader>
          <img style={{ width: "20px" }} src={cdnUrl("/img/loading-grey.webp")} alt="" />
        </Loader>
      }
    </div>
  )
}
